import { apiUrl, mainWeb, mainWebResource } from '../../config/net'

const index = '/vas/test'
const banners = `${apiUrl}/v0/wumao/MobileMallSaasIndex`
const detail = {
  url: `${mainWeb}${mainWebResource}`,
  method: 'getonlinemallpageinfo'
}
const professionId = {
  url: `${mainWeb}${mainWebResource}`,
  method: 'industryid'
}
// 双11专用，获取商品购买信息
const versionBuyInfo = {
  url: `${mainWeb}${mainWebResource}`,
  method: '20181111warmup'
}

// 2018 双11专用，获取商品购买信息
const versionBuyInfo2018 = {
  url: `${mainWeb}${mainWebResource}`,
  method: '20181111official'
}

// 2019 0308 获取当前用户的版本详情
const version20190308 = {
  url: `${mainWeb}${mainWebResource}`,
  method: '20190308_detail'
}

// 可领取的优惠券列表
const receivecoupon20190308 = {
  url: `${mainWeb}${mainWebResource}`,
  method: '20190308_receivecoupon'
}

const version20191111 = {
  url: `${mainWeb}${mainWebResource}`,
  method: '20191111warmup'
}

const mainWebUrl = `${mainWeb}/OnlineMall/ajax/MobileOnlineMall.ashx`
export default {
  index,
  banners,
  detail,
  professionId,
  mainWebUrl,
  versionBuyInfo,
  versionBuyInfo2018,
  version20190308,
  receivecoupon20190308,
  version20191111
}



// WEBPACK FOOTER //
// ./src/model/value-added-service/resource-url.js